import { render } from "./CadastroUsuarioDialog.vue?vue&type=template&id=7772f70a"
import script from "./CadastroUsuarioDialog.vue?vue&type=script&lang=js"
export * from "./CadastroUsuarioDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__